/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    func, bool, arrayOf,
    shape, string, number, array,
} from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactHTMLParser from 'react-html-parser';

import Button from '@material-ui/core/Button';
import Image from '../../../../common/Image';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import { emitCustomTrackingEvent } from '../../../../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import { isEmpty } from '../../../../utils/object';
import { decode as htmlDecode } from '../../../../utils/htmlEntity';
import configEnv from '../../../../config';

const { PERSIST_KEY } = configEnv;

const GiftListProductDetails = (props) => {
    const {
        isReadyState, product, recipient, handleGiftListAddToCart, emitCustomClickTrackingEvent, salesforceAPIResponse,
    } = props;

    if (isEmpty(product)) return null;

    const newName = htmlDecode(product.name);
    const imageURL = (product.image) ? product.image.replace(/^http[s]?:/, 'https:') : '';
    const currentSalesforceCampaign = salesforceAPIResponse.find((sfRecipient) => sfRecipient.recipientItemId === recipient.id) ? salesforceAPIResponse.find((sfRecipient) => sfRecipient.recipientItemId === recipient.id) : {};

    return (
        <>
            <div className="split">
                <div>
                    <Image
                        className="flex-none"
                        style={{ width: '100%' }}
                        src={imageURL}
                        alt={newName}
                    />
                </div>
                <div className="flex-2--">
                    <div className="bold">{ReactHTMLParser(newName)}</div>
                    <div>Item: {product.sku}</div>
                    <div>
                        Price:{' '}
                        {product.discountPrice ? (
                            <>
                                <span className="bold crossed-price">
                                    {product.crossedPrice}
                                </span>
                                <span className="bold discount-price">
                                    {product.discountPrice}
                                </span>
                            </>
                        ) : (
                            <span className="bold">${product.price}</span>
                        )}
                    </div>
                    <div className="bold small">{product.status}</div>
                </div>
            </div>
            <div className="product-content-ul margin-top-2x">
                {ReactHTMLParser(product.content)}
            </div>
            <div className="align-center margin-top-2x">
                <Button
                    className="buttonHD"
                    onClick={() => {
                        handleGiftListAddToCart(product.id, recipient, true);
                        emitCustomClickTrackingEvent({
                            action: 'Click',
                            partNumber: product?.oGPartNumber,
                            salesforceResponse: currentSalesforceCampaign,
                            page: { type: 'gift-list' },
                            eventSubType: 'campaign-tracking',
                        });
                    }}
                >
                    {isReadyState
                        ? `Add For ${recipient.firstname} ${recipient.lastname}`
                        : 'Adding...'}
                </Button>
            </div>
        </>
    );
};

GiftListProductDetails.defaultProps = {
    product: {},
    salesforceAPIResponse: [],
    emitCustomClickTrackingEvent: () => { },
};

GiftListProductDetails.propTypes = {
    product: shape({
        content: string,
        crossedPrice: string,
        discountPrice: string,
        id: string,
        image: string,
        name: string,
        parentCatalogEntryId: string,
        partNumber: string,
        price: number,
        seoproductDisplayURL: string,
        sku: string,
        status: string,
    }),
    recipient: shape({
        AddressBookEntryId: string,
        ContactId: number,
        NamePrefix: string,
        FirstName: string,
        MiddleInitial: string,
        LastName: string,
        NameSuffix: string,
        RelationShip: string,
        NickName: string,
        EmailAddress: string,
        LastUpdateDate: string,
        PhoneNumber: string,
        AlternatePhoneNumber: string,
        Fax: string,
        EmployerName: string,
        NumberOfAddresses: number,
        DateOfBirth: string,
        Addresses: arrayOf(
            shape({
                AddressId: number,
                AddressBookEntryId: string,
                AddressType: string,
                AddressLineOne: string,
                AddressLineTwo: string,
                City: string,
                StateProvince: string,
                PostalCode: string,
                Country: string,
                IsPartialMatch: bool,
                IsUnknownAddress: bool,
                Latitude_degrees: number,
                Longitude_degrees: number,
                IsBillingAddress: bool,
                ContactId: number,
            }),
        ),
    }).isRequired,
    isReadyState: bool.isRequired,
    handleGiftListAddToCart: func.isRequired,
    salesforceAPIResponse: array,
    emitCustomClickTrackingEvent: func,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        product: newState.modal.content.product,
        recipient: newState.modal.content.recipient,
        isReadyState: newState.isReadyState,
        salesforceAPIResponse: newState.giftList.salesforceAPIResponse,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListAddToCart: (productId, recipient, closeModal) => dispatch(EventDispatcher.handleGiftListAddToCart(productId, recipient, closeModal)),
    emitCustomClickTrackingEvent: bindActionCreators(emitCustomTrackingEvent, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(GiftListProductDetails);
